export default __webpack_public_path__ + "slices/main/assets/public/media/logos/fortune.dcb2c27d92a7c8cbeba51a08058a3418.png";